/**
 * Stateless printer status content
 * Contains job data and progress bar
 */

import React, { Component } from 'react';
import StatusProgressBar from './status-progress-bar';
import PrintProgressBar from './print-progress-bar'
import { Button as BSButton, Panel } from 'react-bootstrap';
import Button from "@material-ui/core/Button";
import { DisplayedStatusByPrinterStatusType, PrinterStatusTypes } from "../containers/current_status_section";
import moment from 'moment';
import PropTypes from 'prop-types';
import '../css/prints-item.css';
import '../css/prints-item-animation.css';
import 'react-image-lightbox/style.css';
import ThumbUp from "@material-ui/icons/ThumbUp";
import ThumbDown from '@material-ui/icons/ThumbDown';
import PhoneAndroidSharp from "@material-ui/icons/PhoneAndroidSharp";
import { print_feedback } from '../common/constants'


export default class PrintsItem extends Component {
    constructor(props) {
        super(props);
        this.hasPreviewBeenReloaded = false;
        this.state = {
            isPreviewLoaded: true
        }
    }

    render() {
        const payload = { ...this.props }
        payload.percentage = payload.timeElapsed === 0 && payload.timeLeft === 0 ?
            0 : payload.timeElapsed / (payload.timeElapsed + payload.timeLeft) * 100;
        if (this.props.hidden) {
            return null;
        }

        return this.getPrintCardAndOverlay(payload);
    }

    getPrintCardAndOverlay(payload, transStatus) {
        const { expanded, isStatusItem, status } = this.props;
        // const isOfflineStatus = isStatusItem && status === PrinterStatusTypes.OFFLINE;
        const isOfflineStatus = false; // disabled all offline display
        return (
            <div id='over-write-bootstrap' onClick={(e) => {
                if (isOfflineStatus) return;
                if (!this.props.onClick) return;
                this.props.onClick(e, this.props.index)
            }}>
                <Panel className={`prints-item-panel expanded expanded-${transStatus}`}>
                    {this.makeCard(payload)}
                    <div
                        className={`overlay-collapsed${expanded ? ' overlay-expanded' : ''}${isOfflineStatus ? '' : ' hidden'}`}>
                        <i className='material-icons'>warning</i>Printer Offline
                    </div>
                </Panel>
            </div>
        );
    }

    getTimeDisplayOnBar(timeLeft, transStatus, isPrintCompletedOrCancelled) {
        const timeLeftComponent = this.getHmsComponentFromSeconds(timeLeft);
        return this.props.isStatusItem ?
            <div className={`times-container time-container-animation time-container-${transStatus}`}>
              <span>
                {!isPrintCompletedOrCancelled ? timeLeftComponent : ''}
                  <span>{!isPrintCompletedOrCancelled ? ' Remaining' : DisplayedStatusByPrinterStatusType[this.props.status]}</span>
              </span>
            </div> : null
    }

    getHmsComponentFromSeconds(seconds) {
        if (isNaN(seconds)) {
            return <span>Unknown</span>
        }
        let remainingSecs = seconds % 60;
        let minutes = Math.ceil(seconds / 60) % 60;
        let hours = Math.floor(seconds / 3600);
        return (
            <span>
        {hours === 0 ? null : this.formatTime(hours, 'Hr')}
                {this.formatTime(minutes, 'Min')}
      </span>
        )
    }

    formatTime(number, unit) {
        return (
            <span>
        {number === 0 || number === 1 ? number + ` ${unit} ` : number + ` ${unit}s `}
      </span>)
    }

    makeCard(payload) {
        const { openLightbox } = this.props;
        const {
            percentage, printerName, displayedStatus, resinColor, layerThickness,
            resinUsage, timeLeft, timeElapsed, status, isStatusItem
        } = payload;
        let { modelName, totalPrintTime, feedback } = payload;
        if (!totalPrintTime) {
            totalPrintTime = timeElapsed + timeLeft;
        }
        if (!modelName) {
            modelName = this.props.modelName;
        }
        if (!feedback) {
            feedback = print_feedback.dismiss
        }
        const isPrintCompletedOrCancelled = status === PrinterStatusTypes.END || status === PrinterStatusTypes.CANCEL;
        const previewImageSrc = `https://s3-us-west-1.amazonaws.com/print-preview-image/${payload['previewFileName']}`;

        const Header = ({ feedbackType, isDeskTop }) => {
            const isDeskTopClass = isDeskTop ? "hidden-xs" : "visible-xs";
            return (<div className={`basic-right-container-header ${isDeskTopClass}`}>
                <div className='basic-right-container-items'>
                    <div className='model-name'>{modelName ? modelName : 'N/A'}</div>
                    {isStatusItem ?
                        <PrintProgressBar
                            displayStatus={DisplayedStatusByPrinterStatusType[this.props.status]}
                            isDeskTop={isDeskTop}
                            totalPrintTime={this.getHmsComponentFromSeconds(totalPrintTime)}
                            remainingPrintTime={this.getHmsComponentFromSeconds(timeLeft)}
                            percentage={percentage}
                        /> :
                        <div className='feedback-container'>
                            {feedbackType !== print_feedback.dismiss ?
                                <div className={`feedback-button feedback-button-${feedbackType}`}>
                                    {feedbackType === print_feedback.yes ?
                                        <ThumbUp
                                            className={`button-icon button-icon-${feedbackType}`}/> : (feedbackType === print_feedback.no ?
                                            <ThumbDown className={`button-icon button-icon-${feedbackType}`}/> : "")}
                                    <div>
                                        {feedbackType === print_feedback.yes ? "Satisfied" : (feedbackType === print_feedback.no ? "Not Satisfied" : "Not Rated")}
                                    </div>
                                </div> : ''
                            }
                            <div>{this.timeSpanMessage(payload)}</div>
                        </div>}
                </div>
            </div>)
        }

        const Body = () => <div className='basic-right-container-items'>
            <div className='body-item'>
                <i className='material-icons'>invert_colors</i>
                {resinColor} - {resinUsage}mL
            </div>
            <div className="basic-right-container-items-tails">
                <div className='body-item'>
                    <i className="material-icons">layers</i>
                    {layerThickness ? `${layerThickness} μm` : 'N/A'}
                </div>
                <div className='body-item'>
                    <i className="material-icons">timer</i>
                    {this.getHmsComponentFromSeconds(totalPrintTime)}
                </div>
                <div className='body-item'>
                    <PhoneAndroidSharp style={{ marginRight: 5 }}/>
                    {printerName ? printerName : 'N/A'}
                </div>
            </div>
        </div>

        const FirstColumnOnRight = () => <div className='basic-right-column'>
            <div className='status-and-time-span hidden-xs'>
                <b className='status-container'>{displayedStatus}</b>
                {/*<div className='start-end-time-lb'>{this.timeSpanMessage(payload)}</div>*/}
            </div>
            <div className='resin-and-thickness-container'>
                <div className='body-item'>
                    <i className='material-icons'>invert_colors</i>
                    {resinColor}
                </div>
                <div className='layer-thickness-container'>
                    <i className="material-icons">layers</i>
                    {layerThickness ? `${layerThickness} μm` : 'N/A'}
                </div>
            </div>
        </div>

        const SecondColumnOnRight = () => <div className='basic-right-column pull-left'>
            <div className='bottom-left-responsive visible-xs'>
                <div className='status-container'><span>{displayedStatus}</span></div>
                <div className='start-end-time-lb'>{this.timeSpanMessage(payload)}</div>
            </div>
            <div className='bottom-right-responsive'>
                <div className='time-display'>{this.getHmsComponentFromSeconds(totalPrintTime)}</div>
                <div className='time-display-lb'>Total Print Time</div>
                <div className='volume-display hidden-xs'>{resinUsage} mL</div>
            </div>
        </div>

        const ProgressBarMobile = () => <div className='visible-xs'>
            <StatusProgressBar
                percentage={percentage}
                isExpanded={false}
                isFinished={this.props.status === PrinterStatusTypes.END}
            />
        </div>

        const ProgressBarDesktop = () => <div className='hidden-xs'>
            <StatusProgressBar
                percentage={percentage}
                isExpanded={/*this.props.expanded*/ true}
                isFinished={this.props.status === PrinterStatusTypes.END}
            />
            {this.getTimeDisplayOnBar(timeLeft, null, isPrintCompletedOrCancelled)}
        </div>

        const ControlButtons = () => <div className='control-buttons-group'>
            <BSButton onClick={(e) => {
                e.stopPropagation();
            }} className='cancel-button'>
                <i className='material-icons cancel-icon'>clear</i> Cancel Print
            </BSButton>
            <BSButton onClick={(e) => {
                e.stopPropagation();
            }} className='pause-button'>
                <i className='material-icons pause-icon'>pause</i> Pause Print
            </BSButton>
        </div>

        const ComponentsOnRight = () => <div className='basic-right-container'>
            <Header feedbackType={feedback} isDeskTop={true}/>
            <Body/>
        </div>

        return (
            <div>
                <div className='basic-info-container'>
                    <Header feedbackType={feedback} isDeskTop={false}/>
                    <div className='basic-left-container'>
                        <div className='preview-picture-box' onClick={() => openLightbox(previewImageSrc)}> {
                            this.state.isPreviewLoaded &&
                            <img
                                src={previewImageSrc}
                                onError={ev => this.handleImageNotFound(ev)}
                            />
                        } </div>
                    </div>
                    <ComponentsOnRight/>
                </div>
            </div>
        );
    }

    handleImageNotFound(ev) {
        const { isStatusItem } = this.props;
        if (isStatusItem && !this.hasPreviewBeenReloaded) {
            setTimeout(() => {
                this.setState({ isPreviewLoaded: true });
                this.hasPreviewBeenReloaded = true;
            }, 2000);
        }

        this.setState({ isPreviewLoaded: false });
    }

    timeSpanMessage(payload) {
        const { timeStamp, isStatusItem, totalPrintTime, timeLeft, status } = payload;
        return isStatusItem ?
            `Estimated Completion Time: ${moment(Date.now() + timeLeft * 1000).format('LT')}` :
            status === PrinterStatusTypes.END ?
                `Started at ${moment(timeStamp - totalPrintTime * 1000).format('LT')} and completed at ${moment(timeStamp).format('LT')}` :
                `Cancelled at ${moment(timeStamp).format('LT')}`
    }
}


PrintsItem.propTypes = {
    timeElapsed: PropTypes.number,
    timeLeft: PropTypes.number,
    status: PropTypes.string.isRequired,
    previewFileName: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/prints-item.js